import { Location } from '@angular/common';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Router } from "@angular/router";
import { Address, ContentItem, UpsCacComponent, WidgetOptions } from '@ews/cac';
import { document } from 'ngx-bootstrap/utils';
import { Subscription } from 'rxjs';
import { LocationDetailsSession } from '../../api/models/locationDetailsSession';
import { PickupDetailsSession } from '../../api/models/pickupDetailsSession';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { verificationClientKeyIdRequest } from '../../api/models/verificationClientKeyIdRequest';
import { verificationClientKeyIdResponse } from '../../api/models/verificationClientKeyIdResponse';
import { ApiErrorCode, CAC_CONTENT_TRANSLATION, CAC_FIELD_TYPE_ERROR, CAC_SUPPORTED_COUNTRY, CommonConstants, CONTINENTAL_REGIONS, COUNTRY_LANGUAGE, GlobalFlags, HTML_HEADER, RouteURLConstants, ServiceURLConstants, UTagConstants } from '../../constants/upplm.constants';
import { PLACARD_STATUS } from '../../constants/upplm.constants.dashboard';
import { ClientKeyMatchRequest, ClientKeyMatchResponse } from '../../interface/upplm.clientKey';
import { Error } from '../../interface/upplm.common.interface';
import { GetLocationsRequest, GetLocationsResponse, LocationDetailsSessionRequest } from '../../interface/upplm.locations';
import { AvailableDaysAndServicesSelected, GetPickupScheduleDetailsRequest, PickupScheduleDetailResponse } from '../../interface/upplm.pickupdetails';
import { KeyValue } from '../../interface/upplm.placard';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmLocationDetailsService } from '../../services/upplm.locationDetails.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { TranslationService } from '../../services/upplm.translation.service';
import { UtagService } from '../../services/upplm.utag.service';
import { BreadcrumbItem } from '../commonComponent/ups-breadcrumb/breadcrumbItem';
import { UpsDialogComponent } from '../commonComponent/ups-dialog/ups-dialog.component';

@Component({
    selector: 'locationdetails',
    template: require('./locationDetails.component.html')
})
export class LocationsDetailsComponent implements OnInit, AfterViewInit, AfterViewChecked {
    sessionData: SessionResponse;
    @ViewChild('ConfirmationBox', { static: false }) ConfirmationBoxModal;
    @ViewChild('ups_clientKey', { static: false }) input_ups_clientKey: ElementRef;
    @ViewChildren('errorList') errorList;
    @ViewChild('messages', { static: false }) errorMessagesServer: UpsDialogComponent;
    public messagesErrorServer: string = '';
    options: WidgetOptions = new WidgetOptions();
    @ViewChild(UpsCacComponent, { static: false })
    private cacComponent: UpsCacComponent;
    private Address: Address;
    private _getLocationsRequest: GetLocationsRequest;
    private _getLocationsResponse: GetLocationsResponse;
    private _getPickupScheduleDetailsRequest: GetPickupScheduleDetailsRequest;
    private _getPickupScheduleDetailsResponse: PickupScheduleDetailResponse;
    showClientID: boolean = false;
    private isFirtsAmbiguos: boolean = true;
    public multiPP = new GetLocationsResponse;
    public prueba = new GetLocationsResponse;
    public pbDetails: ProgressBarDetails;
    public isLoadding: boolean = false;
    public applyReadOnly: boolean = false;
    isValidAddress: boolean = false;
    pickuppointview: boolean = false;
    addressMatch: boolean;
    clientKeyFlag: boolean = false;
    labNameFlag: boolean = false;
    Errors: any[];
    client_id: string = '';
    clientKey: string = '';
    nickname: string = '';
    companyName: string = '';
    labName: string = '';
    clientKeyInput: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    labNameInput: string = 'ups-form_input ng-touched ng-dirty ng-valid';
    addressError: string = '';
    validClientKeyFormat: boolean = false;
    private clientVerification: verificationClientKeyIdRequest = new verificationClientKeyIdRequest();
    validationResult: boolean = false;
    isClientValidation: boolean = true;
    validationMessageClientKeyInvalid: boolean = false;
    validationMessageClientKeyInvalidFromURL: boolean = false;
    clientValidation: boolean = true;
    clientKeyMatchResponse: ClientKeyMatchResponse = new ClientKeyMatchResponse;
    validationClientUpdate: boolean = false;
    isDifferentClientKeyId: boolean = false;
    isReviewFlow: boolean = false;
    updateBothAddresses: boolean = false;
    titleText: string = '';
    ManageUPSText = '';
    subscription: Subscription;
    public showRecatpcha: boolean;
    public breadCrumbItems: BreadcrumbItem[] = [];
    cacTranslatedContent: any[] = [];
    availablePickupPlans: string[] = [];
    globalRegionCountry: string = 'NA';
    selectedCountry: string = 'US';
    countryChanged: boolean = false;

    constructor(private _commonService: UpsCommonService,
        private _locationService: UpplmLocationDetailsService,
        private router: Router,
        private _apiService: UpplmApiService,
        private _sessionService: UpplmSessionService,
        private _pbService: ProgressBarService,
        private _utagService: UtagService,
        private location: Location,
        public _translationService: TranslationService,
        private _translateData: TranslateDataPipe
    ) {
        this._getPickupScheduleDetailsResponse = new PickupScheduleDetailResponse();
        this.Address = new Address();
        console.clear();
        this._commonService.versionApp();
        CAC_CONTENT_TRANSLATION.forEach(cacElement => {
            this.cacTranslatedContent.push({ 'key': cacElement.cacKey, 'value': this._translateData.transform(cacElement.key) });
        });
    }

    ngAfterViewChecked(): void {
        this.blockCountryDropDown();
        this.changeCityLegendForEnGb();
    }

    changeCityLegendForEnGb() {
        if (this.selectedCountry === 'GB' || this._commonService.locale === 'en_GB') {
            this.cacComponent.cityFieldState.label = 'City';
        }
    }

    ngOnInit() {
        this.globalRegionCountry = this._commonService.getRegionCountry(this._commonService.locale_country);
        this.selectedCountry = this._commonService.locale_country;
        this.showRecatpcha = (GlobalFlags.DISABLE_RECAPTCHA_PART == 'true') ? true : false;
        this.backBrowser();
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_LOCATION_DETAILS_START, UTagConstants.UPPLM_LOCATION_DETAILS_START_SCREEN);
        this.titleText = `${this._translateData.transform('upplm.breadcrumb.createa')} UPS<sup>${(String.fromCharCode(174))}</sup> Pickup Point`;
        this.ManageUPSText = HTML_HEADER.MANAGE_UPPLOCATION_HEADER;
        this.pbDetails = this._pbService.pb;
        this.options.content = {
            contentItems: this.cacTranslatedContent,
            errorPrefixContentItem: new ContentItem()
        };
        this.setOptions();
        this.clientKeyFlag = false;
        this.clientKeyInput = 'ups-form_input ng-touched ng-dirty ng-valid';
        this.createBreadCrumb();
        setTimeout(() => {
            this.setCountryKeyAndValue();
            this.initCAC();
            this.isLoadding = false;
        });
        this._utagService.resetUTAGData();
    }

    blockCountryDropDown() {
        if (!this.pbDetails.showStatusBar) {
            const countryDropDown = document.getElementsByClassName('ups-dropdown ng-untouched ng-pristine ng-valid');
            if (countryDropDown.length > 0) {
                countryDropDown[0].setAttribute('disabled', 'true');
            }
        }
    }

    existCountryKeyInSessionData(): boolean {
        if (this._sessionService && this._sessionService.sessionData && this._sessionService.sessionData.locationDetails && this._sessionService.sessionData.locationDetails.countryKey) {
            return true;
        }
        return false;
    }

    setCountryKeyAndValue() {
        // If is there something in session for Location details, use this information
        if (this.existCountryKeyInSessionData()) {
            const translatedCountryValue = this._translateData.transform(COUNTRY_LANGUAGE.find(x => x.key === this._sessionService.sessionData.locationDetails.countryKey).value);
            if (this._commonService.isEmeaCountry(this._sessionService.sessionData.locationDetails.countryKey)) {
                this.setValueForCountryChange(false, false, this._sessionService.sessionData.locationDetails.countryKey, translatedCountryValue);
            } else {
                this.setValueForCountryChange(true, false, this._sessionService.sessionData.locationDetails.countryKey, translatedCountryValue);
            }
        } else { // If not, use locale for pre Load CAC data
            this.options.address.country.key = this.selectedCountry ? this.selectedCountry : this._commonService.locale_country;
            this.options.address.country.value = this._translateData.transform(COUNTRY_LANGUAGE.find(x => x.key === this._commonService.locale_country).value);
        }
    }

    initCAC() {
        this.cacComponent.init(this.options).subscribe((response: any) => {
            let mustCallAddressSearch: boolean = false;
            this.isLoadding = true;
            this.showClientID = true; // Mostrar el Client ID                                                              
            // Load location data of the session variables
            this.sessionData = this._sessionService.sessionData;
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(false, false, !this._pbService.pb.showStatusBar)).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess && response.key) {
                    this.sessionData = response;
                    this._sessionService.mapSessionResponse(response);
                    this.validateLocationDetailsSessionData(mustCallAddressSearch);
                }
                this.isLoadding = false;
            });
        });
        
    }

    validateLocationDetailsSessionData(mustCallAddressSearch: boolean) {
        if (this.sessionData.locationDetails) {
            if (!this._pbService.pb.showStatusBar) { //No preogress bar, then review flow
                if (!this.sessionData.temporaryLocation) {//if no temp location then set from location
                    this.sessionData.temporaryLocation = this.sessionData.locationDetails;
                }
                this.bindDataFromSession(this.sessionData.temporaryLocation);
            } else {// Normal Flow, no review
                this.bindDataFromSession(this.sessionData.locationDetails);
            }
            if (this.sessionData.locationDetails.clientKey !== null) {
                this.CallingGetValidationClientKey(mustCallAddressSearch);
            }
        }
    }

    getTranslatedCountryValues(): KeyValue[] {
        let result: KeyValue[] = [];
        CAC_SUPPORTED_COUNTRY.forEach(country => {
            let countryVal = new KeyValue();
            countryVal.key = country.key;
            countryVal.value = this._translateData.transform(country.value);
            result.push(countryVal);
        }, this);
        return result;
    }

    isEmeaCountry(): boolean {
        const country = (this.cacComponent && this.cacComponent.country) ? this.cacComponent.country.key : this.selectedCountry;
        if ((COUNTRY_LANGUAGE.find(x => x.key === country).region) === CONTINENTAL_REGIONS.EMEA) {
            return true;
        }
        return false;
    }

    onCountryChange() {
        if (!this._pbService.pb.showStatusBar || this._sessionService.sessionData.locationDetails.clientKey !== '') { // This indicates is on Review flow
            this.selectedCountry = this._sessionService.sessionData.locationDetails.countryKey;
        }
        if (this.cacComponent.country.key === this.selectedCountry) {
            return;
        } else {
            if ((COUNTRY_LANGUAGE.find(x => x.key === this.cacComponent.country.key).region) === CONTINENTAL_REGIONS.EMEA) {
                this.setValueForCountryChange(false, false, this.cacComponent.country.key, this.cacComponent.country.value);
            } else {
                this.setValueForCountryChange(true, false, this.cacComponent.country.key, this.cacComponent.country.value);
            }
            this.cleanOnBoardingDataSession();
            this.sessionData.locationDetails = new LocationDetailsSession();
            this.sessionData.locationDetails.nickname = '';
            this.sessionData.locationDetails.clientKey = '';
            this.countryChanged = true;
            this.selectedCountry = this.cacComponent.country.key;
            this.initCAC();
        }
    }

    cleanOnBoardingDataSession() {
        this.sessionData.locationDetails = null;
        this.sessionData.temporaryLocation = null;
        this.sessionData.contactDetails = null;
        this.sessionData.placardDetails = null;
        this.sessionData.pickupDetails = null;
        this.sessionData.notificationDetails = null;
        this.sessionData.createPickUp = null;
    }

    setValueForCountryChange(showState: boolean, showInputState: boolean, countryKey: string, CountryValue: string) {
        this.options.showStateInput = function () {
            return showInputState;
        }
        this.options.showState = function () {
            return showState;
        }
        this.options.address.country.key = countryKey;
        this.options.address.country.value = CountryValue;
    }
   
    setOptions() {
        const isEmea = this.isEmeaCountry();
        this.options.countries = this.getTranslatedCountryValues();
        this.options.locale = this._commonService.locale;
        this.options.streetLevelSuggestions = true;
        this.options.validateIntl = false;
        this.options.postalFirstCountries = ["US", "CA", "DE", "FR", "IT", "DE", "GB", "ES"]
        //Show Fields
        this.options.showCountry = function () {
            return true;
        }
        this.options.showName = function () {
            return true;
        }
        this.options.showAddress1 = function () {
            return true;
        }
        this.options.showCity = function () {
            return true;
        }
        this.options.showState = function () {
            return !isEmea;
        }

        this.options.showStateInput = function () {
            return false;
        }

        this.options.showPostal = function () {
            return true;
        }
        //Hidden Fields
        this.options.showAddress2 = function () {
            return false;
        }
        this.options.showAddress3 = function () {
            return false;
        }
        this.options.showContactName = function () {
            return false;
        }
        this.options.showIsResidential = function () {
            return false;
        }
        this.options.showNickname = function () {
            return false;
        }
        this.options.showPhone = function () {
            return false;
        }
        this.options.showPhoneType = function () {
            return false;
        }
        this.options.showExtension = function () {
            return false;
        }
        this.options.showEmail = function () {
            return false;
        }
        this.options.showLocationId = function () {
            return false;
        }
        this.options.showFax = function () {
            return false;
        }
        //Required Fields
        this.options.countryRequired = function () {
            return true;
        }
        this.options.nameRequired = function () {
            return true;
        }
        this.options.address1Required = function () {
            return true;
        }
        this.options.cityRequired = function () {
            return true;
        }
        this.options.stateRequired = function () {
            return !isEmea;
        }
        this.options.postalRequired = function () {
            return true;
        }
        //Non Required fields
        this.options.contactNameRequired = function () {
            return false;
        };
        this.options.phoneRequired = function () {
            return false;
        };
        this.options.emailRequired = function () {
            return false;
        };
        this.options.address1MaxLength = function () {
            return 50;
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    createBreadCrumb() {
        this.breadCrumbItems = [];
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com', this._translateData.transform('upplm.breadcrumb.home')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/services/tracking.page`,
            this._translateData.transform('upplm.breadcrumb.tracking')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/tracking/quantum-view.page`,
            this._translateData.transform('upplm.breadcrumb.manageinboundoutbundshipments')));
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com/upplm/dashboard',
            `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${String.fromCharCode(174)}</sup> Pickup Point ${this._translateData.transform('upplm.breadcrumb.locations')}`));
        this.breadCrumbItems.push(new BreadcrumbItem('', `${this._translateData.transform('upplm.breadcrumb.createa')} UPS<sup>${String.fromCharCode(174)}</sup> Pickup Point`));
    }

    createSessionRequest(update: boolean, goToPickUP: boolean, isTemproraryLocation: boolean): SessionRequest {
        this.isLoadding = true;
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        if (update) {
            const data: LocationDetailsSession = this.getLocationDetailsDataSession();
            let locationDetailsSessionRequest = this.getLocationDetailsSessionRequest(isTemproraryLocation, data);
            request.locationDetails = locationDetailsSessionRequest.locationDetails;
            request.temporaryLocation = locationDetailsSessionRequest.temporaryLocation;

        }
        else {
            request.locationDetails = this.sessionData.locationDetails;
            request.temporaryLocation = this.sessionData.temporaryLocation;
        }
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        if (goToPickUP) {
            let datapDetails = new PickupDetailsSession();
            datapDetails.availableDays = this._getPickupScheduleDetailsResponse.availableDaysAndServices;
            datapDetails.pPlanTypes = this._getPickupScheduleDetailsResponse.pickupPlanTypes;
            datapDetails.errors = this._getPickupScheduleDetailsResponse.errors;
            datapDetails.showPageEdit = true;
            request.pickupDetails = datapDetails;
        }
        else {
            let showPageEditVal = false;
            if (this.sessionData.pickupDetails === null || this.sessionData.pickupDetails.showPageEdit === true) {
                showPageEditVal = true;
                let datapDetails = new PickupDetailsSession();
                datapDetails.availableDays = this._getPickupScheduleDetailsResponse.availableDaysAndServices;
                datapDetails.pPlanTypes = this._getPickupScheduleDetailsResponse.pickupPlanTypes;
                datapDetails.errors = this._getPickupScheduleDetailsResponse.errors;
                datapDetails.showPageEdit = showPageEditVal;
                request.pickupDetails = datapDetails;

            } else {
                request.pickupDetails = this.sessionData.pickupDetails;
            }
        }
        if (this.updateBothAddresses) {
            request.temporaryLocation = request.locationDetails;
        }
        request.notificationDetails = this.sessionData.notificationDetails;
        request.placardID = this.sessionData.placardID;
        request.placardStatus = this.sessionData.placardStatus;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    getLocationDetailsSessionRequest(isTemproraryLocation: boolean, data: LocationDetailsSession): LocationDetailsSessionRequest {
        let request = new LocationDetailsSessionRequest();
        if (isTemproraryLocation) {
            if (this.sessionData.locationDetails != null) {
                if (this.sessionData.locationDetails.city == null) { //No location, then update it
                    request.locationDetails = data;
                } else {
                    request.locationDetails = this.sessionData.locationDetails;
                }
                request.temporaryLocation = data;
            }
        } else {
            request.locationDetails = data;
            request.temporaryLocation = this.sessionData.temporaryLocation;
        }
        return request;
    }

    getLocationDetailsDataSession(): LocationDetailsSession {
        let data: LocationDetailsSession = new LocationDetailsSession();
        data.countryKey = this.cacComponent.country.key;
        data.companyName = this.cacComponent.name;
        data.postal = this.cacComponent.postal;
        data.address1 = this.cacComponent.address1;
        data.city = this.cacComponent.city;
        data.nickname = this.nickname;
        data.clientKey = this.clientKey === '' ? this.sessionData.locationDetails.clientKey : this.clientKey;
        data.state = this.getState();
        data.comesFromURL = this.sessionData.locationDetails.comesFromURL;
        return data;
    }

    bindDataFromSession(data: LocationDetailsSession) {
        if (data.countryKey) {
            this.cacComponent.country = this.options.countries.filter(k => k.key == data.countryKey)[0];
            this.cacComponent.name = data.companyName;
            this.cacComponent.postal = data.postal;
            this.cacComponent.address1 = data.address1;
            this.cacComponent.city = data.city;
            this.cacComponent.state = this._commonService.isEmeaCountry(data.countryKey) ? '' : data.state;
        }
        this.nickname = data.nickname;
        this.clientKey = data.clientKey;
        if (this.nickname !== '') {
            this.validateClientKey(this.nickname);
        }
    }

    public focusoutHandler(field) {
        this.validationMessageClientKeyInvalid = false;
        this.validateClientKey(this.nickname);
        if (field === 'clientKey') {
            this.isClientValidation = true;
            this.clientKeyFlag = true;
            if (this.nickname == '' || !this.nickname || !this.validClientKeyFormat) {
                this.clientKeyInput = 'ups-form_input ng-pristine ng-invalid ups-bodError ng-touched';
            }
            else {
                this.clientKeyInput = 'ups-form_input ng-touched ng-dirty ng-valid';
            }
        }

    }

    NextSave(source: string) {

        this.isLoadding = true;
        this.isReviewFlow = source === 'save' ? true : false;
        this.focusoutHandler('clientKey');
        this.isClientValidation = true;
        this.Errors = [];

        //Validate Session
        if (!this._sessionService.isValidSession()) {//Invalid Session
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {//Valid Session
            //Validate form
            this.cacComponent.formValid();
            //Validate Address
            this.displayErrors();
            if (!this.isValidAddress && this.Errors.length == 0) {
                if (this.cacComponent.isFormValid()) {
                    this.cacComponent.validateAddress().subscribe(response => {
                        this.processValidatonKeyResult(response.validationResult.key);
                    });
                }
            }
        }
        this.isLoadding = false;
    }

    processValidatonKeyResult(validationKeyResult: string) {
        if (validationKeyResult === CommonConstants.VALIDATION_RESULT_KEY_2
            || validationKeyResult === CommonConstants.VALIDATION_RESULT_KEY_0
            || validationKeyResult === CommonConstants.VALIDATION_RESULT_KEY_1) {
            //Invalid Address                     
            if (validationKeyResult === CommonConstants.VALIDATION_RESULT_KEY_0 ||
                validationKeyResult === CommonConstants.VALIDATION_RESULT_KEY_2) {
                this.nextPage();
            } else { //ambiguos, first click, it should be in the same page and allow select any sugested address
                if (this.isFirtsAmbiguos) {
                    this.isFirtsAmbiguos = false;
                } else { //Two clicks on next it must allow to go to next page                                    
                    this.nextPage();
                }
            }
        }
    }

    nextPage() {
        let mustCallAddressSearch: boolean = true;
        //Setting Address from CAC
        this.bindFromForm();

        //NickName was modified?
        this.isDifferentClientKeyId = this.nickname.toLowerCase() !== this.sessionData.locationDetails.nickname.toLowerCase() ? true : false;

        if (!this.applyReadOnly && this.isDifferentClientKeyId) {
            //Enable or disble Nick Name Field
            //Calling GetValidation Client Key            
            this.CallingGetValidationClientKey(mustCallAddressSearch);
        }
        else {
            //Calling AddressSearch
            this.CallingAddressSearch();
        }
    }

    CallingGetValidationClientKey(mustCallAddressSearch: boolean) {
        if (this.sessionData.locationDetails.clientKey != "" || this.sessionData.locationDetails.nickname != "" || this.nickname != "") {
            if (this.sessionData.locationDetails.clientKey.length > 35) {
                this.clientKey = "";
                this.clientValidation = false;
                return;
            }
            this.assignClientKeyToClientVerification(mustCallAddressSearch);
            if (this.clientVerification.clientKey === "") {

                if (this.sessionData.locationDetails.nickname != "" && this.nickname === '') {
                    this.clientVerification.nickName = this.sessionData.locationDetails.nickname;
                }
                else {
                    this.clientVerification.nickName = this.nickname;
                }
            }

            //Max allowed length is 16 characters
            if (!this.applyReadOnly && this.nickname.length > 35 &&
                (!this.sessionData.locationDetails.nickname || this.sessionData.locationDetails.nickname.length == 0)) {
                this.clientValidation = true;
                this.validClientKeyFormat = false;
                return;
            }

            let url = this._commonService.createURL(ServiceURLConstants.GET_VALIDATION_CLIENT_KEY_ID, ApiErrorCode.GET_CLIENTKEY_VALIDATION);

            this.isLoadding = true;
            this._apiService.PostServiceAPIObject(url, this.clientVerification).subscribe((response: verificationClientKeyIdResponse) => {
                this.isLoadding = false;
                this.processClientVerificationResponse(response, mustCallAddressSearch);
            });
        }
    }

    assignClientKeyToClientVerification(mustCallAddressSearch: boolean) {
        if (this.sessionData.locationDetails.clientKey != "") {
            if (mustCallAddressSearch) {
                if (this.input_ups_clientKey.nativeElement.value !== this.sessionData.locationDetails.clientKey) {
                    this.clientVerification.clientKey = this.input_ups_clientKey.nativeElement.value;
                }
            } else {
                this.clientVerification.clientKey = this.sessionData.locationDetails.clientKey;
            }
        } else {
            this.clientVerification.clientKey = this.nickname;
        }
    }

    processClientVerificationResponse(response: verificationClientKeyIdResponse, mustCallAddressSearch: boolean) {
        if (response.errors !== null) {
            if (this.sessionData.locationDetails.comesFromURL) {
                this.clientValidation = false;
                this.validationMessageClientKeyInvalid = false;
                this.validationMessageClientKeyInvalidFromURL = true;
            }
            else {
                if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                    this.messagesErrorServer = response.errors[0].message;
                    this.clientKey = "";
                    this.nickname = "";
                    this.validationMessageClientKeyInvalid = true;
                    this.isLoadding = false;
                    return;
                }
            }
        } else {
            this.validationMessageClientKeyInvalid = false;
            this.validationResult = response.validationResult;
            this.clientKey = response.clientKey;
            this.nickname = response.nickName;
            this.sessionData.locationDetails.nickname = response.nickName;
            this.sessionData.locationDetails.clientKey = response.clientKey;
            this.clientValidation = true;
            if (this.sessionData.locationDetails.comesFromURL) {
                this.applyReadOnly = false;
            }
            if (mustCallAddressSearch) {
                this.CallingAddressSearch();
            }
        }
    }

    CallingAddressSearch() {
        this._getLocationsRequest = new GetLocationsRequest();
        this._getLocationsRequest.address.AddressLine1 = this.Address.address1;
        this._getLocationsRequest.address.CityTown = this.Address.city;
        this._getLocationsRequest.address.StateProvince = this.getStateForRequest();
        this._getLocationsRequest.address.PostalCode = this.Address.postal;
        this._getLocationsRequest.address.CountryCode = this.Address.country.key;
        this.isLoadding = true;
        this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_LOCATIONS, ApiErrorCode.GET_LOCATIONS), this._getLocationsRequest).subscribe((response: any) => {
            this.isLoadding = false;
            if (response.errors !== null && response.errors[0].code !== '0002') {//Any error different to 0002
                if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                    this.messagesErrorServer = response.errors[0].message;
                    this.openModel();
                }
            }

            if (response.errors !== null && response.errors[0].code === '0002') {//Calling locations/services (getPickupScheduleDetails)
                this.CallingLocationServices();
            }
            else {
                this._getLocationsResponse = response;
                this.addressMatch = (this._getLocationsResponse.existingLocations) ? true : false;

                //Updating temporaryLocation in Session
                this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true, false, true)).subscribe((response: SessionResponse) => {
                    this.sessionData = response;
                    this._sessionService.mapSessionResponse(response);
                    if (this.addressMatch) { //Calling Key Match
                        this.CallingKeyMatch();
                    }
                    else {//Temporary location doesn't exist then storing as location details in session
                        this.sessionData.locationDetails = this.sessionData.temporaryLocation;
                        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true, false, false)).subscribe((response: SessionResponse) => {
                            this.sessionData = response;
                            this.storeLocationDetailsInSession();
                        });
                    }
                });
            }
            this.isLoadding = false;
        });
    }

    getStateForRequest(): string {
        if (this._commonService.isEmeaCountry(this.cacComponent.country.key)) return '';
        return this.Address.state;
    }

    storeLocationDetailsInSession() {
        if (!this.isReviewFlow) {
            this.CallingLocationServices();
        }
        else {
            let savedAddress = this.sessionData.locationDetails;
            if (this.cacComponent.address1.toLowerCase() !== savedAddress.address1.toLowerCase()
                || this.cacComponent.city.toLowerCase() !== savedAddress.city.toLowerCase()
                || this.cacComponent.state.key !== savedAddress.state
                || this.cacComponent.country.key !== savedAddress.countryKey
                || this.cacComponent.postal !== savedAddress.postal) {
                this.CallingLocationServices();
            }
            else {
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE, false, false);
            }
        }
    }

    CallingLocationServices() {
        this._getPickupScheduleDetailsRequest = new GetPickupScheduleDetailsRequest();
        this.createRequestOnFlowType();
        this.Errors.forEach(element => {
            if (this.Errors[element].id === 'stringAddress') {
                this.Errors.splice(element, 1);
            }
        });
        this.isLoadding = true;

        let url = this._commonService.createURL(ServiceURLConstants.GET_UPPLM_PICKUP_DETAILS, ApiErrorCode.GET_UPPLM_PICKUP_DETAILS);
        this._apiService.PostServiceAPI(url, this._getPickupScheduleDetailsRequest).subscribe((response: PickupScheduleDetailResponse) => {
            this.isLoadding = false;

            this._getPickupScheduleDetailsResponse.availableDaysAndServices = response.availableDaysAndServices;
            this._getPickupScheduleDetailsResponse.pickupPlanTypes = response.pickupPlanTypes;
            this._getPickupScheduleDetailsResponse.errors = response.errors;

            this.isLoadding = false;
            if (response.errors !== null) {
                this.noScheduleAvailable(response.errors);
            }
            else {
                if (!this.isReviewFlow) {//Goto Contact
                    this._pbService.pb = new ProgressBarDetails();
                    this._pbService.pb.locationPB = "true";
                    this.updateBothAddresses = true;
                    this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_CONTACT_DETAILS_ROUTE, false, false);
                }
                else {
                    if (!this.isValidSchedule()) {//New Schedule not valid
                        this.sessionData.pickupDetails.showPageEdit = true;
                        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PICKUP_DETAILS_ROUTE, true, false);
                    } else {//Schedue valid, navigate to Review                        
                        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE, false, false);
                    }
                }
            }
        });
    }

    createRequestOnFlowType() {
        if (!this.isReviewFlow) {
            this.createRequest();
        } else {
            this.createAvailableItemsRequest();
        }
    }

    noScheduleAvailable(errors: Error[]) {
        if (errors.filter(x => x.code === '10008')) {
            const addressInvalid = [{
                "id": "stringAddress",
                "displayText": this._translateData.transform("upplm.locationdetails.error.notablereceivepickups"),
                "type": "info",
                "fieldName": "Invalid Addresss error",
                "fieldError": "Invalid Addresss error",
                "fieldErrorDescription": "field Error"
            }
            ];
            this.Errors = this.Errors.concat(addressInvalid);
            return;
        }
        //Any other Error, Display modal
        if (errors[0].message !== '' || errors[0].message !== null) {
            this.messagesErrorServer = errors[0].message;
            this.openModel();
            return;
        }
    }

    CallingKeyMatch() {
        let PickupPointNumberPlacardId: Array<string> = [];
        this._getLocationsResponse.existingLocations.forEach(element => {
            PickupPointNumberPlacardId.push(element.pickupPointNumber);
        });

        let clientKeyMatchRequest = new ClientKeyMatchRequest();
        clientKeyMatchRequest.clientKey = this.sessionData.locationDetails.clientKey;
        clientKeyMatchRequest.placardIdList = PickupPointNumberPlacardId;

        this.isLoadding = true;
        this._apiService.PostServiceAPI(this._commonService.createURL(ServiceURLConstants.GET_CLIENT_KEY_MATCH, ApiErrorCode.GET_CLIENT_KEY_MATCH), clientKeyMatchRequest).subscribe((response: any) => {
            this.isLoadding = false;
            this.clientKeyMatchResponse = response;
            if (this.clientKeyMatchResponse.errors !== null && this.clientKeyMatchResponse.errors[0].code !== '0002') {//Any Error
                if (this.clientKeyMatchResponse.errors[0].message !== '' || this.clientKeyMatchResponse.errors[0].message !== null) {
                    this.messagesErrorServer = this.clientKeyMatchResponse.errors[0].message;
                    this.openModel();
                    return;
                }
            }
            else {
                this.sessionData.placardStatus = this.clientKeyMatchResponse.placardStatus;
                this.sessionData.placardID = this.clientKeyMatchResponse.placardId;
                if (this.clientKeyMatchResponse.clientKeymatch) { //ClientKey MATCH                    
                    this.onClientKeyMatch();
                }
                else {//ClientKey NOT MATCH
                    if (this.sessionData.placardStatus === PLACARD_STATUS.DISPATCHED) {//Add Client Key
                        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_PLACARD_ADD_CLIENT_KEY, false, false);
                    }
                    else {//No Dispatched, go to Contact Details
                        this.CallingLocationServices();
                    }
                }
            }
        });
    }

    onClientKeyMatch() {
        if (this.sessionData.placardStatus !== PLACARD_STATUS.CREATED
            && this.sessionData.placardStatus !== PLACARD_STATUS.EXPIRED) { //Placard Confirmed
            if (this.sessionData.placardStatus === PLACARD_STATUS.DISPATCHED) {// Dispatched, go to PlacardAlreadyExists
                this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_EXISTS_ROUTE, false, false);
            } else {//No Dispatched, go to Contact Details
                this.CallingLocationServices();
            }
        } else { // Placard NOT Confirmed
            //Go to Confirm Placard Display
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_EXISTS_CONFIRMATION_ROUTE, false, false);
        }
    }

    isValidSchedule(): boolean {
        let isValid: boolean = true;

        //Validate New Schedule
        this._getPickupScheduleDetailsResponse.availableDaysAndServices.forEach(element => {
            if (element.validTime === false) {
                isValid = element.validTime;
                return;
            }
        });
        this.updateBothAddresses = true;
        return isValid;
    }

    cancelGoReviewPage() {
        let request = this.createSessionRequest(false, false, false);
        request.temporaryLocation = request.locationDetails;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
            this.sessionData = response;
            this._sessionService.mapSessionResponse(response)
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_REVIEW_ROUTE);
        });
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    createRequest() {
        this._getPickupScheduleDetailsRequest.address.AddressLine1 = this.cacComponent.address1;
        this._getPickupScheduleDetailsRequest.address.CityTown = this.cacComponent.city;
        this._getPickupScheduleDetailsRequest.address.StateProvince = this.cacComponent.state.key;
        this._getPickupScheduleDetailsRequest.address.CountryCode = this.cacComponent.country.key;
        this._getPickupScheduleDetailsRequest.address.PostalCode = this.cacComponent.postal;
        this._getPickupScheduleDetailsRequest.preferredOptions = null;
        this._getPickupScheduleDetailsRequest.clientKey = this.clientKey;
    }

    createAvailableItemsRequest() {
        this._getPickupScheduleDetailsRequest.address.AddressLine1 = this.cacComponent.address1;
        this._getPickupScheduleDetailsRequest.address.CityTown = this.cacComponent.city;
        this._getPickupScheduleDetailsRequest.address.StateProvince = this.cacComponent.state.key;
        this._getPickupScheduleDetailsRequest.address.CountryCode = this.cacComponent.country.key;
        this._getPickupScheduleDetailsRequest.address.PostalCode = this.cacComponent.postal;
        this._getPickupScheduleDetailsRequest.clientKey = this.clientKey;
        this._getPickupScheduleDetailsRequest.preferredOptions.pickupPlanTypeSelected.pickupPlanType = this.sessionData.pickupDetails.pickupType;
        this.sessionData.pickupDetails.allSchedule.forEach(element => {
            if (element.preferredSelected !== '-1' && element.latestSelected !== '-1') {
                const availableDaysAndServicesSelected: AvailableDaysAndServicesSelected = new AvailableDaysAndServicesSelected();
                availableDaysAndServicesSelected.dayOfWeekCode = element.dayOfWeekCode;
                availableDaysAndServicesSelected.timeZone = this.sessionData.pickupDetails.availableDays.filter(x => x.dayOfWeekCode === element.dayOfWeekCode)[0].timeZone;
                availableDaysAndServicesSelected.selectedPreferredTime = element.preferredSelected;
                availableDaysAndServicesSelected.selectedLatestTime = element.latestSelected;
                this._getPickupScheduleDetailsRequest.preferredOptions.availableDaysAndServicesSelected.push(availableDaysAndServicesSelected);
            }
        });
    }

    validateSessionAndNavigate(target: string, goToPickUP: boolean, isTemporaryLocation: boolean) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest(true, goToPickUP, isTemporaryLocation)).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    this._sessionService.mapSessionResponse(response);
                    this.sessionData = response;
                    let allowNavigate: boolean = false;
                    switch (target) {
                        case RouteURLConstants.UPPLM_VIEW_PLACARD_EXISTS_ROUTE:
                        case RouteURLConstants.UPPLM_VIEW_PLACARD_EXISTS_CONFIRMATION_ROUTE:
                        case RouteURLConstants.UPPLM_VIEW_PLACARD_PLACARD_ADD_CLIENT_KEY:
                            this._pbService.pb.showStatusBar = false;
                            allowNavigate = true;
                            break;
                        default:
                            allowNavigate = this.validatePickupDetails();
                            break;
                    }
                    if (allowNavigate) {
                        this.router.navigateByUrl(target);
                    }
                }
            });
        }
    }

    validatePickupDetails(): boolean {
        if (this.sessionData.pickupDetails) {
            if (this.sessionData.pickupDetails.availableDays) {
                return true;
            } else {
                this.messagesErrorServer = this._translateData.transform("upplm.common.serviceerror");
                this.openModel();
                return false;
            }
        }
        else {
            this.messagesErrorServer = this._translateData.transform("upplm.common.serviceerror");
            this.openModel();
            return false;
        }
    }

    displayErrors() {
        this.cacComponent.getFormErrors().forEach(errorRow => {
            if (!errorRow.type.includes('info') && !errorRow.type.includes('sysErr')) {
                    this.Errors = this.Errors.concat(this.addError(errorRow.id, `${this._translateData.transform(CAC_FIELD_TYPE_ERROR.find(x => x.id === errorRow.type && x.field === errorRow.fieldName).key)}`, errorRow.type));
            } else {
                this.Errors = this.Errors.concat(this.addError(errorRow.id, errorRow.displayText, ''));
            }
        });

        if (this.nickname == '' || !this.nickname) {
            this.validationMessageClientKeyInvalid = false;
            this.Errors = this.Errors.concat(this.addError('ups_clientKey', this._translateData.transform('upplm.locationdetails.error.clientkeynamerequired'), ('is Required')));
        }
        else if (!this.validClientKeyFormat) {
            this.validationMessageClientKeyInvalid = false;
            this.Errors = this.Errors.concat(this.addError('ups_clientKey', this._translateData.transform('upplm.locationdetails.error.clientkeyinvalidformat'), ('is invalid')));
        } else if (this.validationMessageClientKeyInvalid && this.clientKey !== '') {
            this.Errors = this.Errors.concat(this.addError('ups_clientKey', this._translateData.transform('upplm.locationdetails.error.clientkeyinvalid'), ('is invalid')));
        }
    }

    ngAfterViewInit() {
        this.ConfirmationBoxModal.setProperties({
            title: this._translateData.transform('upplm.common.sessiontimedouttitle')
        });
        this.blockCountryDropDown();;
    }

    bindFromForm() {
        this.Address = new Address();
        this.Address.address1 = this.cacComponent.address1;
        this.Address.city = this.cacComponent.city;
        this.Address.country.key = this.cacComponent.country.key;
        this.Address.state = this.getState();
        this.Address.postal = this.cacComponent.postal;
    }

    getState(): string {
        if (this._commonService.isEmeaCountry(this.cacComponent.country.key)) return '';
        return this.cacComponent.state.key;
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    addError(id: string, field: string, condition: string): any {
        return [{
            "id": id,
            "displayText": field,
            "type": condition,
            "fieldName": "Name",
            "fieldError": "Name error",
            "fieldErrorDescription": "field Error"
        }];
    }

    public openModel() {
        this.errorMessagesServer.open();
    }

    public closeModal() {
        this.errorMessagesServer.close();
    }

    validateClientKey(keyToValidate: string) {
        const validClientKeyRegEx = /^\w[a-zA-Z0-9\b \b]*$/;
        this.validClientKeyFormat = validClientKeyRegEx.test(keyToValidate) ? true : false;
        this.clientKeyFlag = true;
        this.validationMessageClientKeyInvalid = false;
    }

    backBrowser() {
        this.subscription = <Subscription>this.location.subscribe(val => {
            switch (val.url) {
                case '/dashboard':
                    this._pbService.pb.showStatusBar = false;
                    this._commonService.url = '/dashboard';
                    this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
                    break;
            }
        });
    }
}
